import { Component, Prop, h } from '@stencil/core';
import { ArrowRight } from './svg';

@Component({
  tag: 'amp-icon',
  styleUrls: ['../../base.css'],
  shadow: true,
})
export class AmpIcon {
  /**
   * SVG icon to render
   */
  @Prop() svg: string;
  /**
   * Height in px
   */
  @Prop() height: string;
  /**
   * Width in px
   */
  @Prop() width: string;

  render() {
    const iconSVG = this.svg;
    const iconHeight = this.height || '12px';
    const iconWidth = this.width || '12px';

    let icon;

    switch (iconSVG) {
      case 'ArrowRight':
        icon = <ArrowRight height={iconHeight} width={iconWidth} />;
        break;
    }

    return icon;
  }
}
